__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "my-basic-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@date-fns/utc", "2.1.1", () => (__webpack_require__.e(8075).then(() => (() => (__webpack_require__(68075))))));
			register("@react-querybuilder/dnd", "5.4.1", () => (Promise.all([__webpack_require__.e(311), __webpack_require__.e(9637)]).then(() => (() => (__webpack_require__(80311))))));
			register("chart.js", "4.5.1", () => (__webpack_require__.e(7304).then(() => (() => (__webpack_require__(17304))))));
			register("date-fns", "3.6.0", () => (__webpack_require__.e(4194).then(() => (() => (__webpack_require__(64194))))));
			register("driver.js", "0.9.8", () => (__webpack_require__.e(9718).then(() => (() => (__webpack_require__(9718))))));
			register("lodash", "4.18.1", () => (__webpack_require__.e(3536).then(() => (() => (__webpack_require__(53536))))));
			register("mobx-react", "7.6.0", () => (Promise.all([__webpack_require__.e(6233), __webpack_require__.e(4627)]).then(() => (() => (__webpack_require__(96233))))));
			register("mobx", "6.16.1", () => (__webpack_require__.e(4812).then(() => (() => (__webpack_require__(64812))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(6178).then(() => (() => (__webpack_require__(86178))))));
			register("muuri-react", "3.1.7", () => (Promise.all([__webpack_require__.e(7447), __webpack_require__.e(1784)]).then(() => (() => (__webpack_require__(37447))))));
			register("muuri", "0.9.5", () => (__webpack_require__.e(5947).then(() => (() => (__webpack_require__(45947))))));
			register("query-string", "7.1.3", () => (__webpack_require__.e(9370).then(() => (() => (__webpack_require__(9370))))));
			register("react-accessible-accordion", "4.0.0", () => (__webpack_require__.e(4705).then(() => (() => (__webpack_require__(64705))))));
			register("react-bootstrap", "0.32.4", () => (Promise.all([__webpack_require__.e(8296), __webpack_require__.e(9351)]).then(() => (() => (__webpack_require__(48296))))));
			register("react-chartjs-2", "5.3.1", () => (__webpack_require__.e(3677).then(() => (() => (__webpack_require__(6058))))));
			register("react-confirm-alert", "2.8.0", () => (__webpack_require__.e(917).then(() => (() => (__webpack_require__(20917))))));
			register("react-datepicker", "6.9.0", () => (Promise.all([__webpack_require__.e(5885), __webpack_require__.e(1899), __webpack_require__.e(9603)]).then(() => (() => (__webpack_require__(31899))))));
			register("react-dnd-html5-backend", "16.0.1", () => (__webpack_require__.e(1586).then(() => (() => (__webpack_require__(21586))))));
			register("react-dnd", "16.0.1", () => (__webpack_require__.e(7042).then(() => (() => (__webpack_require__(87042))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(97950))), 1);
			register("react-error-boundary", "3.1.4", () => (__webpack_require__.e(9177).then(() => (() => (__webpack_require__(59177))))));
			register("react-miller-columns", "1.0.0", () => (__webpack_require__.e(9809).then(() => (() => (__webpack_require__(19809))))));
			register("react-querybuilder", "5.4.1", () => (__webpack_require__.e(6213).then(() => (() => (__webpack_require__(76213))))));
			register("react-reflex", "4.2.7", () => (Promise.all([__webpack_require__.e(6053), __webpack_require__.e(5173)]).then(() => (() => (__webpack_require__(86053))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(3945), __webpack_require__.e(2582)]).then(() => (() => (__webpack_require__(62582))))));
			register("react-router", "5.3.4", () => (Promise.all([__webpack_require__.e(3945), __webpack_require__.e(1688), __webpack_require__.e(7554)]).then(() => (() => (__webpack_require__(91688))))));
			register("react-select", "5.10.2", () => (Promise.all([__webpack_require__.e(5885), __webpack_require__.e(7235), __webpack_require__.e(803)]).then(() => (() => (__webpack_require__(47235))))));
			register("react-table", "7.8.0", () => (__webpack_require__.e(1094).then(() => (() => (__webpack_require__(71094))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(65043))), 1);
			register("universal-cookie", "8.1.2", () => (__webpack_require__.e(4750).then(() => (() => (__webpack_require__(34750))))));
			register("web-vitals", "2.1.4", () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(46453))))));
			initExternal(78192);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};